import { useInjection } from 'inversify-react';

import { Panel } from '@desygner/ui-common-components';

import { IViewerStoreInjector, TYPES } from '../../../../../../inversify.config';
import { EditProject } from '../EditProject/EditProject';
import { UseProject } from '../UseProject/UseProject';

export type ProjectActionsProps = {
  type: 'bottomsheet' | 'desktop';
};

export const ProjectActions = ({ type }: ProjectActionsProps) => {
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const isProjectUsable = useViewerStore((state) => state.isProjectUsable);
  const isProjectEditable = useViewerStore((state) => state.isProjectEditable);

  if (type === 'desktop') {
    return (
      <>
        {isProjectUsable && (
          <Panel.Content>
            <UseProject type="desktop" />
          </Panel.Content>
        )}
        {isProjectEditable && (
          <Panel.Content>
            <EditProject type="desktop" />
          </Panel.Content>
        )}
      </>
    );
  }

  return (
    <>
      {isProjectUsable && <UseProject type="bottomsheet" />}
      {isProjectEditable && <EditProject type="bottomsheet" />}
    </>
  );
};
